export interface Tenant {
  code?: TenantCode;
  id?: number;
  urlPattern?: string;
  theme?: string;
  preferedLanguage?: string;
  useNemId?: boolean;
  appTitle?: string;
  useVideoFeature?: boolean;
  selfRegistration?: boolean;
  defaultClinicProfile?: boolean;
  clinicAccessToAssignments?: boolean;
  clinicSearchAccess?: boolean;
  flexibleSchedule?: boolean;
}

export enum TenantCode {
  Kailo = 'KAILO' as any,
  PrimaCare = 'PRIMACARE' as any,
  Kailo_Demo = 'KAILO-DEMO' as any
}